// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3joph","savePackageButton":"ClientWallet_savePackageButton__2oSK0"};